
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ExchangeHero from './components/ExchangeHero';
import HowItWorks from './components/HowItWorks';
import MembershipRequirements from './components/MembershipRequirements';
import VerificationSection from './components/VerificationSection';
import PortalPreview from './components/PortalPreview';
import ExampleListings from './components/ExampleListings';
import IncubatorConnection from './components/IncubatorConnection';
import AccessApplication from './components/AccessApplication';
import { updateSEO, generateExchangeSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function Exchange() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || window.location.origin;
    
    const seoData = {
      title: 'AI Business Exchange - Exclusive Marketplace for Verified AI Companies',
      description: 'Join our exclusive exchange to access verified AI businesses, agencies, and SaaS platforms. Connect with serious buyers and sellers in the AI industry.',
      keywords: 'AI business exchange, AI marketplace, verified AI companies, AI agency acquisition, AI business for sale, exclusive marketplace',
      ogTitle: 'AI Business Exchange - Exclusive Marketplace for Verified AI Companies',
      ogDescription: 'Join our exclusive exchange to access verified AI businesses, agencies, and SaaS platforms. Connect with serious buyers and sellers in the AI industry.',
      ogImage: 'https://public.readdy.ai/ai/img_res/4187934d30fd74478c660b90d5e7150a.jpg',
      twitterCard: 'summary_large_image',
      canonicalUrl: `${siteUrl}/exchange`,
      structuredData: [
        generateExchangeSchema(),
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Exchange', url: '/exchange' }
        ])
      ]
    };

    updateSEO(seoData);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <ExchangeHero />
        <HowItWorks />
        <MembershipRequirements />
        <VerificationSection />
        <PortalPreview />
        <ExampleListings />
        <IncubatorConnection />
        <AccessApplication />
      </main>
      <Footer />
    </div>
  );
}
